/* SALTY SEA – Startseiten-Raster (sections/saltysea-home-grid.liquid)
   - Kategorie-Chips schalten zwischen den Produkt-Panels um und passen den Button darunter an
   - Quick-Add-Fallback (falls die Theme-JS den Klick nicht selbst übernimmt): add.js → Quick-Cart neu laden → Drawer öffnen */
(function () {
  'use strict';

  var routeRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function refreshQuickCart() {
    var qc = document.querySelector('.quick-cart');
    if (!qc) return Promise.resolve(false);
    var wrap = qc.closest('[id^="shopify-section-"]');
    if (!wrap) return Promise.resolve(true);
    var id = wrap.id.replace('shopify-section-', '');
    return fetch(routeRoot + 'cart?section_id=' + encodeURIComponent(id))
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return true;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        [
          '.quick-cart__wrapper .quick-cart__items',
          '.quick-cart__wrapper .quick-cart__heading sup',
          '.quick-cart__wrapper .quick-cart__footer-subtotal span',
          '.quick-cart__wrapper .quick-cart__item-discounts'
        ].forEach(function (sel) {
          var fresh = doc.querySelector(sel), live = document.querySelector(sel);
          if (fresh && live) live.innerHTML = fresh.innerHTML;
        });
        if (!document.querySelector('.quick-cart__wrapper .quick-cart__items') || !doc.querySelector('.quick-cart__wrapper .quick-cart__items')) {
          var liveC = document.querySelector('.quick-cart__container'), freshC = doc.querySelector('.quick-cart__container');
          if (liveC && freshC) liveC.innerHTML = freshC.innerHTML;
        }
        return true;
      })
      .catch(function () { return true; });
  }

  function openDrawer() {
    var icon = document.querySelector('[data-js-cart-icon]');
    if (icon) {
      icon.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      return true;
    }
    return false;
  }

  function quickAdd(btn) {
    var label = btn.querySelector('[data-label]');
    var original = label ? label.textContent : '';
    btn.setAttribute('aria-busy', 'true');

    fetch(routeRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-ss-variant')), quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error((data && (data.description || data.message)) || 'Nicht verfügbar');
          return data;
        });
      })
      .then(function (data) {
        var item = Array.isArray(data.items) ? data.items[0] : data;
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { detail: { item: item } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item: item } }));
        if (label) label.textContent = 'Hinzugefügt ✓';
        return refreshQuickCart().then(function (hasDrawer) {
          if (!hasDrawer || !openDrawer()) window.location.href = routeRoot + 'cart';
        });
      })
      .catch(function (err) {
        if (label) label.textContent = (err && err.message) ? err.message : 'Nicht verfügbar';
      })
      .then(function () {
        btn.removeAttribute('aria-busy');
        setTimeout(function () { if (label) label.textContent = original; }, 2000);
      });
  }

  function init(root) {
    if (!root || root.dataset.ssReady) return;
    root.dataset.ssReady = '1';

    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-ss-panel]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-ss-panel-id]'));
    var more = root.querySelector('[data-ss-more]');

    function show(id) {
      var target = null;
      panels.forEach(function (p) {
        var on = p.getAttribute('data-ss-panel-id') === id;
        p.hidden = !on;
        if (on) target = p;
      });
      chips.forEach(function (c) {
        var on = c.getAttribute('data-ss-panel') === id;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (more && target) {
        var l = target.getAttribute('data-ss-more-label');
        var u = target.getAttribute('data-ss-more-url');
        if (l) more.textContent = l;
        if (u) more.setAttribute('href', u);
      }
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () { show(chip.getAttribute('data-ss-panel')); });
    });

    // Quick-Add-Fallback (die Theme-JS stoppt die Weitergabe, wenn sie den Klick selbst übernimmt)
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ss-quick]');
      if (!btn || btn.getAttribute('aria-busy') === 'true') return;
      e.preventDefault();
      quickAdd(btn);
    });
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('.ss-home')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme-Editor: neu gerenderte Section initialisieren
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('.ss-home') : null;
    init(el);
  });
})();
